//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//
// Please note that the values of RowClickBehavior and ViewType are shared with the TradeBlotterConfig.
import type { RowClickBehavior, ViewType } from './trade-blotter'

export const MOMENT_MARKETS_TRADE_BLOTTER_SCHEMA_VERSION = '1.0'

export interface TradeDeskTradeBlotterConfig {
  rowClickBehavior: RowClickBehavior
  viewType: ViewType
}
